define('views/blocks/SideNavView',['underscore','jquery','backbone','app',
        'TagCommander',
        'WidgetCollectionView',
        'template!blocks/side-nav', 'router', 'SelectView', 'site_vars'],
    function (_,$,Backbone,app,
              TagCommander,
              WidgetCollectionView,
              sideNavTemplate, router, SelectView, site_vars) {

    //
    // SideNav View
    //

    //
    // le header est un singleton,
    //
    var view, // singelton
        menuView;

    return Backbone.View.extend({

        el:'.side-nav',
        events: {
            'click > .btn-close, .overlay' : 'closeNav',
            'click .widget-menu .link': 'trackClick',
            'change select.lang-select' : 'switchLang',
        },
        initialize:function(){

            view = this;
            view.render();
            // quand un changement de route a lieu, on ferme le menu automatiquement
            view.listenTo(router,'route',$.proxy(view.closeNav,view));
            // on écoute un event app pour l'ouverture du menu
            view.listenTo(app,'openSideNav', view.openNav);
        },

        render:function(){
            view.$el.empty();
            view.$el.html(sideNavTemplate({languages: app.getLanguages()}));
            view.renderMenu();
            SelectView.initializeSelectsOfView(view);
        },

        renderMenu:function(){
            if(menuView){
                menuView.remove();
            }
            // var menuHamburgerView = view.menuView = new WidgetCollectionView('menuhamb');
            var menuHamburgerView = menuView = new WidgetCollectionView('menuhamb');
            view.$('.content').prepend(menuHamburgerView.el);

        },

        switchLang:function(){
            var option = view.$('.lang-select option:selected'),
                iso = option.val();
            TagCommander.eventGA(option,"header","language",iso);
            window.location= site_vars.base_url + iso.toLowerCase() + '/';
        },

        trackClick:function(e){
            var currentTarget = e.currentTarget,
                $a = $(currentTarget);
            TagCommander.eventGA(currentTarget,"header","Clic",$a.text());
        },

        toggleNav:function(active){
            view.$el.toggleClass('active',active);
        },

        openNav: function(){
            view.toggleNav(true);
        },

        closeNav: function(){
            view.toggleNav(false);
        }

    });
});

